import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel, UIComponentProps } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { ToneDto } from '../../../../core/dto/tonedto';
import { ToneRowViewImpl } from './tonerowview';
import { EnglishToneRowCSSStyle } from './englishtonerowcss';
import { APIModelHandler, APIModel } from '../../uicomponentapimodel';
import { ToneRowAPIModelImpl, ToneRowAPIModel } from './tonerowapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { APIFeatures } from '../../../../core/util/apifeatures';

export interface ToneRowComponentProps extends UIComponentProps
{
    toneDto:ToneDto;
    position: number;
    cssStyle: EnglishToneRowCSSStyle;
    toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    onTuneSettingsAdded(toneDto: ToneDto): void;
    onDeleteClicked(toneDto: ToneDto): void;
}

export interface ToneRowComponentHandler extends UIComponentHandler
{
    onDeleteClicked(): void;
    showHideMoreActions(isShow: boolean): void;
    addToWishlist(): void;
    onRowSelected(): void;
}


export interface ToneRowComponentState extends UIComponentState
{
    isShowHideMoreActions: boolean;
}

export interface ToneRowOptionsPrivilage
{
    isGift(): boolean;
    isShare(): boolean;
    isDelete(): boolean;
    isTellAFriend(): boolean;
    isAddWishlist(): boolean;
    isToneSelect(): boolean;
    isBuy(): boolean;
    isLike(): boolean;
    isPlay(): boolean;
    isSettings(): boolean;
    isAction(): boolean;
    isStatus(): boolean;
    isPreview():boolean;
}


export class ToneRowOptionsPrivilageImpl implements ToneRowOptionsPrivilage
{
    private status: boolean = false;
    private delete: boolean = false;
    private gift: boolean = false;
    private share: boolean = false;
    private tellafriend: boolean = false;
    private addwishlist: boolean = false;
    private buy: boolean = false;
    private like: boolean = true;
    private play: boolean = true;
    private preview: boolean = true;
    private action: boolean = true;
    private settings: boolean = false;
    private toneSelect: boolean = false;

    isToneSelect(): boolean {
       return this.toneSelect;
    }

    setStatus(status: boolean): void
    {
        this.status = status;
    }

   setDelete(delete1: boolean): void
   {
    this.delete = delete1;
   }
    setGift(gift: boolean): void
    {
        this.gift = gift;
    }
    
    setShare(share: boolean): void
    {
        this.share = share;
    }
    
    setTellAFriend(tellafriend: boolean): void
    {
        this.tellafriend = tellafriend;
    }
    
    setAddWishList(addwishlist: boolean): void{
        this.addwishlist = addwishlist;
    }

    setIsToneSelect(isSelect: boolean): void{
        this.toneSelect = isSelect;
    }

    setBuy(buy: boolean): void
    {
        this.buy = buy;
    }
    
    setLike(like: boolean): void{
        this.like = like;
    }
    
    setPlay(play: boolean): void{
        this.play = play;
    }   
    setPreview(preview: boolean): void{
        this.preview = preview;
    }
    setAction(action: boolean)
    {
        this.action = action;
    }
    
    setSettings(settings: boolean)
    {
        this.settings = settings;
    }

    isStatus(): boolean {
       return this.status;
    }
    isDelete(): boolean {
        return this.delete;
    }
    isGift(): boolean 
    {
        return this.gift;
    }
    isShare(): boolean {
        return this.share;
    }
    isTellAFriend(): boolean {
        return this.tellafriend;
    }
    isAddWishlist(): boolean {
        return this.addwishlist;
    }

    isBuy(): boolean {
        return this.buy;
    }    
    isLike(): boolean {
        return this.like;
    }
    isPlay(): boolean {
        return this.play;
    }
    isSettings(): boolean {
        return this.settings;
    }
    isAction(): boolean {
        return this.action;
    }

    isPreview():boolean {
        return this.preview;
    }
}


export class ToneRowOptionsPrivilageFromJsonImpl extends ToneRowOptionsPrivilageImpl
{
    private jsonData: any;

    fromJson(jsonData: any)
    {
        this.jsonData = jsonData;

        console.log("-----previlage: " + JSON.stringify(this.jsonData));
    }

    isStatus(): boolean {
        return this.jsonData.status;
     }
     isDelete(): boolean {
         return this.jsonData.delete;
     }
     isGift(): boolean 
     {
         return this.jsonData.gift;
     }
     isShare(): boolean {
         return this.jsonData.share;
     }
     isTellAFriend(): boolean {
         return this.jsonData.tellafriend;
     }
     isAddWishlist(): boolean {
         return this.jsonData.addwishlist;
     }
 
     isBuy(): boolean {
         return this.jsonData.buy;
     }    
     isLike(): boolean {
         return this.jsonData.like;
     }
     isPlay(): boolean {
         return this.jsonData.play;
     }
     isSettings(): boolean {
         return this.jsonData.settings;
     }
     isAction(): boolean {
         return this.jsonData.action;
     }
 
     isPreview():boolean {
         return this.jsonData.preview;
     }
}

export class ToneRowComponent extends UIComponentImpl<ToneRowComponentProps, ToneRowComponentState, UIDataModel> 
implements ToneRowComponentHandler
{
    constructor(props: ToneRowComponentProps)
    {
        super(props);

        this.state = {isShowHideMoreActions: false};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneRowViewImpl(this.props.toneRowOptionsPrivilage, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.cssStyle;
        // if(applicationContext.getUserContext().getLanguage() === LanguageConst.)
        // {
        //     return new EnglishToneRowCSSStyleImpl(applicationContext);
        // }
        // return new ArabicToneRowCSSStyleImpl(applicationContext);
    }
    
    showHideMoreActions(isShow: boolean): void {
       this.setState({isShowHideMoreActions: isShow});
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToneRowAPIModelImpl(applicationContext, apiModelHandler);
    }

    addToWishlist(): void {
        (this.getAPIModel() as ToneRowAPIModel).addToWishlist(this.props.toneDto);
    }

    onRowSelected(): void 
    {
        let toneDto = this.props.context.getToneContext();

        if(toneDto)
        {
            toneDto.setId(this.props.toneDto.getId());
            toneDto.setToneName(this.props.toneDto.getToneName());
            toneDto.setArtistName(this.props.toneDto.getArtistName());
            toneDto.setImgPath(this.props.toneDto.getImgPath());
            toneDto.setToneUrl(this.props.toneDto.getToneUrl());
            toneDto.setLikeCount(this.props.toneDto.getLikeCount());
            toneDto.setStatus(this.props.toneDto.getStatus());
            toneDto.setTonePrivilage(this.props.toneRowOptionsPrivilage);
            // toneDto.setLikeCount("11234");
            toneDto.setPrice(this.props.toneDto.getPrice());
            this.props.context.setToneContext(toneDto);
    
            // this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
            // "/" + RoutingFeatures.PREVIEW_TONE + "?tone-id=" + this.props.toneDto.getId(), false);
        }
    }

    onDeleteClicked(): void 
    {
        (this.getAPIModel() as ToneRowAPIModel).deleteTone(this.props.toneDto);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.ADD_TO_WISHLIST)
        {

        }
        else 
        {
            this.props.onDeleteClicked(this.props.toneDto);
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowcomponent.tsx